import React from "react";
import { Route, Switch } from "react-router-dom";
import ViewHome from "./Home";
import TeamOrder from "./TeamOrder";
import Error from "./Error";
import Help from "./Help";
import GroupOrder from "./GroupOrder";
import Report from "./Report";
import { ToastContainer } from "react-toastify";
import ManageMembers from "./ManageMembers";
import EmailNotification from "./EmailNotificationSetting";
import DeliveryControlPanel from "./DeliveryControlPanel";
import { SundayTeamLunch } from "./GroupOrder";

const View = () => {
  return (
    <>
      <ToastContainer progressClassName="fancy-progress-bar" />
      <Switch>
        <Route
          exact
          path="/grouporder-dashboard/:slug_uuid"
          component={GroupOrder}
        />
        <Route exact path="/error" component={Error} />
        <Route
          exact
          path="/grouporder-dashboard/:slug_uuid/reports"
          component={Report}
        />
        <Route
          exact
          path="/grouporder-dashboard/:slug_uuid/manage-members"
          component={ManageMembers}
        />
        <Route
          exact
          path="/grouporder-dashboard/:slug_uuid/email-notification"
          component={EmailNotification}
        />
        <Route
          exact
          path="/grouporder-dashboard/:slug_uuid/delivery-control-panel"
          component={DeliveryControlPanel}
        />
        <Route exact path="/" component={Help} />
        <Route exact path="/sunday-team-lunch" component={SundayTeamLunch} />
        <Route exact path="/:uuid" component={TeamOrder} />
        <Route exact path="/group_order/:slug_uuid" component={ViewHome} />
      </Switch>
    </>
  );
};
export default View;
